import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RolepermissionService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();
  excelContent: any;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  getModuleList(): Observable<any> {
    return this.apiService.get(APIs.getMainModuleList).pipe(map(response => {
      return response;
    }));
  }

  getUserRoleList(): Observable<any> {
    return this.apiService.get(APIs.getMainUserRoleList).pipe(map(response => {
      return response;
    }));
  }

  getPermissionList(): Observable<any> {
    return this.apiService.get(APIs.getMainPermissionTypeList).pipe(map(response => {
      return response;
    }));
  }

  updateModuleRolePermission(data): Observable<any> {
    return this.apiService.post(APIs.updateRolePermissionData, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getModuleWiseRolePermission(id) {
    return this.apiService.get(`${APIs.getModuleWiseRolePermission}?moduleId=${id}`).pipe(map(response => {
      if (response.isValid) {
      }
      return response;
    }))
  }

  getTheUserList(data): Observable<any> {
    return this.apiService.post(APIs.getUserList, data).pipe(map(response => {
      return response;
    }));
  }

  addUserRoleMappping(data): Observable<any> {
    return this.apiService.post(APIs.addUserRoleMapping, data).pipe(map(response => {
      return response;
    }));
  }

  removeUserRolePermission(id: string): Observable<any> {
    let parkId = localStorage.getItem('parkId');
    return this.apiService.delete(APIs.removeUserRoleMapping + '?employeeRoleMappingId=' + id + '&parkId=' + parkId).pipe(map(response => {
      return response;
    }));
  }

  // removeUserRolePermission(id: string): Observable<any> {
  //   let parkId = localStorage.getItem('parkId');
  //   return this.apiService.delete(APIs.removeUserRoleMapping + '?employeeRoleMappingId=' + id + '&parkId=' + parkId).pipe(map(response => {
  //     return response;
  //   }));
  // }

  getPermissionByEmployeeId(id) {
    return this.apiService.get(`${APIs.permissionByEmployee}?empId=${id}`).pipe(map(response => {
      if (response.isValid) {
      }
      return response;
    }))
  }

  getDisablePermissionTypeByModule(id) {
    return this.apiService.get(`${APIs.GetPermissionTypeByModule}?moduleId=${id}`).pipe(map(response => {
      if (response.isValid) {
      }
      return response;
    }))
  }
}
